module.exports = __webpack_public_path__ + "img/paper.903b1a1e.svg";